import React from 'react'
import { Badge, Button, Col, Form, Row } from 'react-bootstrap';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import styles from './quizTemplateConfiguration.module.scss'
import { CustomButton } from '../../../../../shared/customButton';

const QuizTemplateConfiguration = (props) => {

    const onSubmit = (values) => {

        props.nextPage(2)
        props.setSubmitValues(values)
    }
    const schema = yup.object({
        quizName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        quizSpecialization: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),

        //subject_areas: yup.array().min(1,'At least one subject area is required. Enter the subject area and click "Add" button.').required('Required'),

        subjectareaToBeAdded: yup.string().when('subject_areas', {
            is: (subject_areas) => (subject_areas), then: ()=> yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('duplicate subject check', 'Duplicate subject area', function (item) {
                if ((this.parent.subject_areas.indexOf(item)) != -1) {
                    return false;
                } else {
                    return true;
                }
            }), otherwise: () => yup.string()
        }),
        duration: yup.number().typeError('Only numbers allowed').integer('Invalid input').moreThan(4, 'Duration should be more than 5 mins or equal to 5 mins.').lessThan(120, 'Should be less than 120 min').required('Required'),
        Description: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),

    })

    return (
        <div>
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ quizName: props.values.quizName, quizSpecialization: props.values.quizSpecialization, subjectareaToBeAdded: props.values.subjectareaToBeAdded, subject_areas: props.values.subject_areas, duration: props.values.duration ? props.values.duration : 5, Description: props.values.Description ? props.values.Description : null }}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label className={styles.textareaLabel}>
                                Quiz Name &nbsp;
                                <svg data-tooltip-id={`quizTemplateNameToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <ReactTooltip id={`quizTemplateNameToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                    <div className={styles.toolTipBox}><p>This is only for internal recruiting team’s reference.</p></div>
                                </ReactTooltip>

                            </Form.Label>
                            <div className={styles.filedWrap} >
                            <CustomTextField
                                name="quizName"
                                classLabel="defaultLabel"
                                controlId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizNameFieldId"
                                placeholder="ex:- Software Engineering Technical Test"
                                type="text"
                                disabled={false}
                                value={values.quizName}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.quizName}
                                validationMessageId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizNameValidationMsgId"
                                isInvalid={submitCount > 0 && !!errors.quizName}
                            />
                            </div>
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label className={styles.textareaLabel}>
                                Quiz Specialization &nbsp;
                                <svg data-tooltip-id={`quizTemplateSpecializationToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <ReactTooltip id={`quizTemplateSpecializationToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                    <div className={styles.toolTipBox}><p> What knowledge areas you want to evaluate in candidates. This will help candidate to prepare for the quiz. Ex: - Programming Knowledge, Creativity, IQ Test, etc.</p></div>
                                </ReactTooltip>

                            </Form.Label>
                            <div className={styles.filedWrap} >
                            <CustomTextField
                                //label="Quiz Specialization"
                                name="quizSpecialization"
                                classLabel="defaultLabel"
                                controlId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizSpecializationFieldId"
                                placeholder="ex:- Software Engineering Fundamentals"
                                type="text"
                                disabled={false}
                                value={values.quizSpecialization}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.quizSpecialization}
                                validationMessageId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_quizSpecializationValidationMsgId"
                                isInvalid={submitCount > 0 && !!errors.quizSpecialization}
                            />
                            </div>
                        </Form.Group>

                    {/*   <Form.Group className={styles.formText} controlId="multiEmail">
                            <Form.Label
                                className={styles.defaultLabel}>
                                Subject Areas &nbsp;
                                <svg data-tooltip-id={`quizTemplateSubjectAreasToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <ReactTooltip id={`quizTemplateSubjectAreasToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                    <div className={styles.toolTipBox}><p> Which subject areas you want to cover. Ex:- Design Principles, Digital Marketing, Java, etc.</p></div>
                                </ReactTooltip>
                            </Form.Label>                          
                            <div className={styles.keywordInputFormDiv}>
                                <Form.Control
                                    className={styles.defaultTextBox}
                                    name="subjectareaToBeAdded"
                                    id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_subjectsAreasFieldId"
                                    type="text"
                                    value={values.subjectareaToBeAdded || ''}
                                    onChange={(e) => { setFieldValue('subjectareaToBeAdded', e.target.value) }}
                                    isInvalid={submitCount > 0 && !!errors.subjectareaToBeAdded}
                                    errorMessage={errors.subjectareaToBeAdded}
                                />
                                <Button type="button" variant="primary" className={styles.keywordAddBtn} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_subjectAreasAddBtnId" disabled={!!errors.subjectareaToBeAdded}
                                    onClick={((values.subjectareaToBeAdded).length > 0) ? () => { values.subject_areas.push(values.subjectareaToBeAdded); setFieldValue('subjectareaToBeAdded', ''); } : null}
                                >Add</Button>
                            </div>
                            {errors.subjectareaToBeAdded &&
                                <span className={styles.errorMsg} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_subjectsAreasValidationMsgId" >{errors.subjectareaToBeAdded}</span>
                            }
                            {submitCount > 0 && errors.subject_areas && !errors.subjectareaToBeAdded &&
                                <span className={styles.errorMsg} id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_subjectAreasValidationMsgId">{errors.subject_areas}</span>
                            }
                            <Row xs="auto" className="mt-2 mb-4">
                                {
                                    values.subject_areas.map((item, i) => (
                                        (
                                            <Col className="ms-0 me-0 mt-2">
                                            <div className={styles.subjectareasbadgeDiv} key={i}>
                                                    <Badge bg="light" className={styles.keywordbadge} id={`adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_AddedsubjectArea.${i}`}>{item}&nbsp;&nbsp;
                                                    <span onClick={() => { values.subject_areas.splice(i, 1); setFieldValue('subject_areas', values.subject_areas) }}>
                                                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.5 3.5L3.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M3.5 3.5L10.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </Badge>
                                            </div>
                                            </Col>
                                        )
                                    ))
                                }
                            </Row>

                        </Form.Group>*/}
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label className={styles.textareaLabel}>
                                Time Limit (in minutes) &nbsp;
                                <svg data-tooltip-id={`quizTemplateDurationToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <ReactTooltip id={`quizTemplateDurationToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                    <div className={styles.toolTipBox}><p> Maximum time to answer all questions in minutes. Minimum value allowed is 5 mins, maximum value allowed is 120 mins.</p></div>
                                </ReactTooltip>

                            </Form.Label>

                            <div className={styles.filedWrap} >
                            <CustomTextField
                                //label="Quiz Time Period"
                                name="duration"
                                placeholder="minutes"
                                classLabel="defaultLabel"
                                controlId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_durationFieldId"
                                type="number"
                                value={values.duration}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.duration}
                                validationMessageId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_durationValidationMsgId"
                                isInvalid={submitCount > 0 && !!errors.duration}
                            />
                            </div>
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label className={styles.textareaLabel}>
                                Description (Optional)&nbsp;
                                <svg data-tooltip-id={`quizTemplateDescriptionToolTip`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                <ReactTooltip id={`quizTemplateDescriptionToolTip`} place="right" type="dark" effect="solid" clickable={true}>
                                    <div className={styles.toolTipBox}><p> A brief description. This will be visible to candidates.</p></div>
                                </ReactTooltip>

                            </Form.Label>

                            {/* <Form.Control as="textarea" name="Description" value={values.Description} onChange={handleChange} rows={3} className={styles.textareaBox} /> */}
                            <CustomTextArea
                                name="Description"
                                controlId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_descriptionTextAreaId"
                                values={values.Description}
                                errorMessage={errors.Description}
                                validationMessageId="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_descriptionValidationMsgId"
                                handleChange={handleChange}
                                isInvalid={submitCount > 0 && !!errors.Description}
                            // remainingCount={(values.guidelineDescription).length}
                            // maxLength={800}
                            />
                        </Form.Group>
                        <hr className={styles.dividerLine} />

                        <div className='d-flex flex-row-reverse'>
                            <div className='mt-2'>
                                <CustomButton
                                    id="adminPanel_evaluationTemplates_quizTemplates_createQuizTemplateModal_quizTemplateConfiguration_nextBtnId"
                                    buttonType="submit"
                                    label="Review"
                                    type="primaryBtn"
                                />
                            </div>
                        </div>

                    </Form>
                )}

            </Formik>
        </div>
    )
}

export default QuizTemplateConfiguration